import {Component, Input, OnChanges, OnInit} from '@angular/core';
import { BankTransactionsSummary } from '@portal-workspace/grow-shared-library';
import { LooseCurrencyPipe } from '../../pipes/loose-currency.pipe';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass } from '@angular/common';
import { MatTableModule } from '@angular/material/table';

@Component({
    selector: 'overdrawn-table',
    templateUrl: './overdrawn-table.component.html',
    styleUrls: ['./overdrawn-table.component.scss'],
    standalone: true,
    imports: [MatTableModule, NgClass, ExtendedModule, LooseCurrencyPipe]
})
export class OverdrawnTableComponent implements OnInit, OnChanges {
  @Input({ required: true }) data!: BankTransactionsSummary;
  dataSource: BankTransactionsSummary[] = [];
  columnsToDisplay: string[] = ['totaldebit', 'numdebit'];
  moreWidth: boolean = false;

  constructor() {}

  ngOnInit(): void {
    if (this.data) {
      this.dataSource = [this.data];
    }

    if (this.data?.numcredit && this.data?.numcredit > 0) {
      this.columnsToDisplay = ['totaldebit', 'numdebit', 'totalcredit', 'numcredit'];
      this.moreWidth = true;
    }
  }

  ngOnChanges() {
    this.moreWidth = false;
    this.columnsToDisplay = ['totaldebit', 'numdebit'];
    if (this.data) {
      this.dataSource = [this.data];
    }

    if (this.data?.numcredit && this.data?.numcredit > 0) {
      this.columnsToDisplay = ['totaldebit', 'numdebit', 'numcredit', 'totalcredit'];
      this.moreWidth = true;
    }
  }

  getColumnTitles(column: string): string {
    switch (column) {
      case 'totaldebit': return '$ Overdrawn';
      case 'totalcredit': return '$ Overdrawn Reversal';
      case 'numdebit': return '# Overdrawn';
      case 'numcredit': return '# Overdrawn Reversal';
      default: return column;
    }
  }

  needCurrencyPipe(column: string) {
    return ['totaldebit', 'totalcredit'].includes(column);
  }
}
